import { jsx } from 'react/jsx-runtime';
import { FlexBox } from '@vp/swan';
import 'react';
import { useHelpSpokeStore } from '../../../../../stores/index.js';
import { Iterator } from '../../../../../@core/components/ui/iterator/iterator.js';
import { isItemActionable } from '../../../../../utils/Order.js';
import { OrderItem } from './OrderItem.js';

const OrderItemsList=({items})=>{const{itemsChecks,customerProblem,remediatedItems,deferredPayment}=useHelpSpokeStore();return jsx(FlexBox,{gap:"5",flexWrap:"wrap",style:{maxWidth:675},children:jsx(Iterator,{of:items,render:(item,index)=>jsx(OrderItem,{disabled:!isItemActionable(item,customerProblem,remediatedItems,deferredPayment,itemsChecks),item:item},`item-${item.id}-${index}`)})})};

export { OrderItemsList };
//# sourceMappingURL=OrderItemsList.js.map
